import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { fadeInSlideAnimation } from 'animations';
import { SpotData } from 'dto/spotdata';
import { RemoteServicesProvider } from 'providers/remote-services/remote-services';
import { LocalstorageProvider } from 'providers/localstorage/localstorage';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { TranslationProvider } from 'providers/translation/translation';
import { TranslateService } from '@ngx-translate/core';
import { ImageResizeProvider } from 'providers/image-processor/image-resize';
import { PopupMessage, MessageService } from 'rb-core-library';
import { ImageProcessorProvider } from 'providers/image-processor/image-processor';

@Component({
    selector: 'app-newspot-images',
    templateUrl: './newspot-images.component.html',
    styleUrls: ['./newspot-images.component.scss'],

    animations: [fadeInSlideAnimation],
    host: { '[@fadeInSlideAnimation]': '' }
})
export class NewspotImagesComponent implements OnInit, OnDestroy {

    spotData: SpotData = null;
    isLoading: boolean = false;

    @ViewChild("captureImageInput") captureImageInput;
    @ViewChild("uploadImageInput") uploadImageInput;

    constructor(
        private appService: AppService,
        private router: Router,
        public remoteService: RemoteServicesProvider,
        public translateService: TranslateService,
        private domainStorageProvider: DomainStorageProvider,
        private imageResizeProvider: ImageResizeProvider,
        private imageProcessorProvider: ImageProcessorProvider,
        public messageService: MessageService
    ) {
        this.messageService.popupMessage = null;
        this.showHideMenu(false);
        this.setupImageProcessor();
    }

    ngOnInit() {
        this.spotData = this.domainStorageProvider.rootStore.spotData.value;
        if (!this.spotData) {
            this.router.navigate(["/searchpos"]);
        }
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    back() {
        this.router.navigate(["/newspot"]);
    }

    canSendPhotos() {
        return this.spotData.photos.length < 8;
    }

    clearInputs() {
        this.captureImageInput.nativeElement.value = "";
        this.uploadImageInput.nativeElement.value = "";
    }

    setupImageProcessor(){
        this.imageProcessorProvider.resultEvent.subscribe((e) => {
            
            if (e.status == 1) {
                this.spotData.createOrUpdatePhoto(e.data);
            }
            else {
                let popupMessage: PopupMessage = {
                    type: 'danger',
                    text: this.translateService.instant("NewspotRegisterPhotos.ErrorUploading"),
                    timeout: 3000
                };
                this.messageService.addMessage(popupMessage);

                this.spotData.removeInvalidPhoto();
            }

            this.isLoading = false;
        });
    }
    
    async fileChangeEvent(fileInput: any) {
        if (fileInput.target.files && fileInput.target.files[0]) {
            this.isLoading = true;

            this.spotData.createOrUpdatePhoto(null);
            this.imageProcessorProvider.processImage(fileInput.target.files[0], 800, 800);

            /*
            await this.imageResizeProvider.resizeImage(fileInput.target.files[0], 800, 800).then(image => {
                this.spotData.createOrUpdatePhoto(image);
            }, err => {

                let popupMessage: PopupMessage = {
                    type: 'danger',
                    text: this.translateService.instant("NewspotRegisterPhotos.ErrorUploading"),
                    timeout: 3000
                };
                this.messageService.addMessage(popupMessage);

                this.spotData.removeInvalidPhoto();
            });*/
        }
    }
}
